<!--
 * @Date: 2024-06-20 17:04:15
 * @Author: jm
 * @LastEditTime: 2024-06-20 20:07:59
 * @LastEditors: jm
 * @FilePath: \arcadearchipelago\src\components\Skeleton.vue
 * @Description: 
-->
<template>
  <div>
    <GamesMore :leftIcon="'High Score'" :leftText="'High Score'">
      <template #content>
        <div class="main1">
          <a class="main1-item loading" v-for="(item, index) in 15" :key="item">
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore :leftIcon="'Most People Play'" :leftText="'Most People Play'">
      <template #content>
        <div class="main2">
          <a class="main2-item loading" v-for="(item, index) in 10" :key="item">
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore :leftIcon="'Popular Game'" :leftText="'Popular Game'">
      <template #content>
        <div class="main3">
          <a
            class="main3-item loading"
            v-for="(item, index) in 10"
          >
          </a>
        </div>
      </template>
    </GamesMore>
  </div>
</template>

<script>
import GamesMore from "@/components/GamesMore.vue";
export default {
  name: "Skeleton",
  components: {
    GamesMore,
  },
};
</script>

<style lang="scss" scoped>
.main1 {
  width: 1000px;
  margin: 38px auto;
  display: flex;
  flex-wrap: wrap;
  .main1-item:nth-child(3n-1) {
    margin: 0px 50px;
  }
  .main1-item {
    width: 300px;
    height: 432px;
    background-color: #d8d8d8;
    margin-bottom: 40px;
  }
}
.main2 {
  width: 1000px;
  margin: 38px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .main2-item {
    width: 480px;
    height: 200px;
    background-color: #d8d8d8;
    display: flex;
    margin-bottom: 40px;
  }
}

.main3 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .main3-item {
      width: 480px;
      height: 424px;
      background-color: #d8d8d8;
      margin-bottom: 40px;
      position: relative;
    }
  }

.loading {
  background: linear-gradient(90deg, #f2f2f2 25%, #d1d1d1 40%, #f2f2f2 50%);
  background-size: 400% 100%;
  animation: loading 1.4s ease infinite;
}

@keyframes loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}
</style>
